import React, { ChangeEvent, useState, useEffect } from 'react';
import IconTextInput from '../../components/IconTextInput';
import IconTextEmail from '../../components/IconTextEmail';
import MaskedIconTextInput from '../../components/IconTextInput/masked';
import { TitleService, TextCircle, TextBudget } from '../../styles/typography';
import { Container, Row } from '../styles';
import { FaPhone, FaUser, FaEnvelopeOpen } from 'react-icons/fa';
import TextArea from '../../components/TextArea';
import { Button } from '../../components/Button/styles';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { DevBudgetState, ResponseI } from '../../redux/types/devBudgetTypes';
import { toast } from 'react-toastify';
import api from '../../services/api';
import Loader from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import ToggleButtons from '../../components/ToggleButtons';
import 'react-phone-input-2/lib/bootstrap.css';

const Budget: React.FC = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [showSizeError, setShowSizeError] = useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const devBudget = useSelector<DevBudgetState, DevBudgetState['devBudget']>(
    state => state.devBudget,
  );

  type ITarget = {
    target: {
      name: string;
      value: string;
    };
  };

  const handleChange = (
    e:
      | ChangeEvent<HTMLInputElement>
      | ChangeEvent<HTMLSelectElement>
      | ChangeEvent<HTMLTextAreaElement>
      | ITarget,
    isRadio?: boolean,
  ) => {
    const { name, value } = e.target;

    if (isRadio) {
      setSelected(value);
    }

    // Remove erro de size quando selecionar
    if (name === 'size' && showSizeError) {
      setShowSizeError(false);
    }

    dispatch({ type: 'ADD_DEV_BUDGET', payload: { [name]: value } });
  };

  const handleSubmit = async () => {
    const { description, name, phone, size } = devBudget;

    if (!size) {
      setShowSizeError(true);
    }

    // const { gtagReportConversion } = window as any;
    if (description && name && phone && size) {
      // gtagReportConversion();
      // ReactGA.event({
      //   category: 'Conversion',
      //   action: 'Conversion',
      // });
      const utmSource = localStorage.getItem('utm_source');
      const utmMedium = localStorage.getItem('utm_medium');
      const utmCampaign = localStorage.getItem('utm_campaign');
      const utmTerm = localStorage.getItem('utm_term');
      const utmContent = localStorage.getItem('utm_content');
      const allUtmNull = !(
        utmSource ||
        utmMedium ||
        utmCampaign ||
        utmTerm ||
        utmContent
      );

      // eslint-disable-next-line camelcase
      const utm_info = allUtmNull
        ? null
        : `utm_source=${utmSource || ''}&utm_medium=${utmMedium || ''}` +
          `&utm_campaign=${utmCampaign || ''}&utm_term=${utmTerm || ''}` +
          `&utm_content=${utmContent || ''}`;

      const payload = {
        ...devBudget,
        utm_info,
      };

      setDisabled(true);
      await api
        .post('/budget/dev', payload)
        .then(({ data }: ResponseI): void => {
          toast.success(data.message);
          setFormSubmitted(true);
          history.push('nos-conheca');
        })
        .catch(({ response }) => {
          toast.error(response.data.message);
          setDisabled(false);
        });
    } else {
      toast.error('Preencha todos os campos para continuar!');
    }
  };

  const companySizeOptions = [
    { label: t('company-size-1-10') || '1 to 10', value: '1 a 10' },
    { label: t('company-size-11-50') || '11 to 50', value: '11 a 50' },
    { label: t('company-size-51-100') || '51 to 100', value: '51 a 100' },
    {
      label: t('company-size-above-100') || 'Above 100',
      value: 'Acima de 100',
    },
  ];

  useEffect(() => {
    const handleBeforeUnload = async (e: BeforeUnloadEvent) => {
      const { description, name, phone, size } = devBudget;

      // Verifica se há dados no formulário e se ainda não foi enviado
      if (!formSubmitted && (description || name || phone || size)) {
        // Previne o comportamento padrão para dar tempo de enviar
        e.preventDefault();
        e.returnValue = '';

        // Envia o formulário usando os UTMs já armazenados
        const utmSource = localStorage.getItem('utm_source');
        const utmMedium = localStorage.getItem('utm_medium');
        const utmCampaign = localStorage.getItem('utm_campaign');
        const utmTerm = localStorage.getItem('utm_term');
        const utmContent = localStorage.getItem('utm_content');
        const allUtmNull = !(
          utmSource ||
          utmMedium ||
          utmCampaign ||
          utmTerm ||
          utmContent
        );

        // eslint-disable-next-line camelcase
        const utm_info = allUtmNull
          ? null
          : `utm_source=${utmSource || ''}&utm_medium=${utmMedium || ''}` +
            `&utm_campaign=${utmCampaign || ''}&utm_term=${utmTerm || ''}` +
            `&utm_content=${utmContent || ''}`;

        const payload = {
          ...devBudget,
          utm_info,
        };

        // Usa sendBeacon para envio assíncrono garantido
        const blob = new Blob([JSON.stringify(payload)], {
          type: 'application/json',
        });
        navigator.sendBeacon('/budget/dev', blob);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [devBudget, formSubmitted]);

  return (
    <Container>
      {/* <Title>
        {t('budget-title')} <span>{t('budget-title2')} </span>
        {t('budget-title3')}
      </Title>
      <TextCircle>{t('budget-subtitle')}</TextCircle>
      <Row style={{ marginBottom: 10 }}>
        <div
          className={'radio'}
          style={
            selected === 'De R$ 50.000 até R$ 80.000'
              ? { backgroundColor: '#dc1e45' }
              : {}
          }
        >
          <input
            type="radio"
            name="budget"
            value="De R$ 50.000 até R$ 80.000"
            id="radio1"
            readOnly
            onChange={e => handleChange(e, true)}
          />
          <label htmlFor="radio1"> {t('budget-valor1')} </label>
        </div>
        <div
          className={'radio'}
          style={
            selected === 'De R$ 80.000 até R$ 110.000'
              ? { backgroundColor: '#dc1e45' }
              : {}
          }
        >
          <input
            type="radio"
            name="budget"
            value="De R$ 80.000 até R$ 110.000"
            id="radio2"
            readOnly
            onChange={e => handleChange(e, true)}
          />{' '}
          <label htmlFor="radio2">{t('budget-valor2')}</label>
        </div>
        <div
          className={'radio'}
          style={
            selected === 'De R$ 110.000 até R$ 150.000'
              ? { backgroundColor: '#dc1e45' }
              : {}
          }
        >
          <input
            type="radio"
            name="budget"
            value="De R$ 110.000 até R$ 150.000"
            id="radio3"
            readOnly
            onChange={e => handleChange(e, true)}
          />{' '}
          <label htmlFor="radio3">{t('budget-valor3')}</label>
        </div>
        <div
          className={'radio'}
          style={
            selected === 'Mais de R$ 150.000'
              ? { backgroundColor: '#dc1e45' }
              : {}
          }
        >
          <input
            type="radio"
            name="budget"
            readOnly
            id="radio4"
            onChange={e => handleChange(e, true)}
            value="Mais de R$ 150.000"
          />{' '}
          <label htmlFor="radio4">{t('budget-valor4')}</label>
        </div>
      </Row> */}
      <TitleService style={{ marginTop: 80 }}>
        {t('budget-title4')} <span>{t('budget-title5')} </span>
        {t('budget-title6')}
      </TitleService>
      <TextBudget>
        {t('budget-text')}
        <br /> {t('budget-text2')}
      </TextBudget>
      <Row className="no-gap">
        <IconTextInput
          icon={FaUser}
          onChange={e => handleChange(e)}
          name="name"
          placeholder={t('budget-nome')}
        />
        <MaskedIconTextInput
          icon={FaPhone}
          placeholder={t('budget-telefone')}
          onChange={e => handleChange(e)}
          name="phone"
        />
      </Row>
      <Row className="no-gap">
        <IconTextEmail
          icon={FaEnvelopeOpen}
          onChange={e => handleChange(e)}
          name="email"
          placeholder={t('budget-email')}
        />
      </Row>
      <Row className="no-gap">
        <TextArea
          placeholder={t('budget-ideia')}
          onChange={e => handleChange(e)}
          name="description"
        />
      </Row>
      <TextBudget>
        {t('budget-text3')} <br />
        {t('budget-text4')}
      </TextBudget>
      <Row className="no-gap">
        <TextArea
          placeholder={t('budget-textarea')}
          onChange={e => handleChange(e)}
          name="timming"
        />
      </Row>
      <TextBudget>{t('company-size')}</TextBudget>
      <ToggleButtons
        options={companySizeOptions}
        onChange={(value: string) =>
          handleChange({ target: { name: 'size', value } })
        }
        hasError={showSizeError}
      />
      {disabled ? (
        <div style={{ margin: 40 }}>
          <Loader
            type="TailSpin"
            width="50"
            height="50"
            color="var(--secondary-300)"
          />
        </div>
      ) : (
        <Button
          style={{ marginTop: 40 }}
          disabled={disabled}
          onClick={handleSubmit}
        >
          {t('budget-button')}
        </Button>
      )}
    </Container>
  );
};

export default Budget;
